/** @format */

import {AccountsKpiName} from 'graphql/generated/types';

import {ChartIds} from '../models/chartIds';

const getChartIdByKpiName = (name: AccountsKpiName): ChartIds => {
  switch (name) {
    case 'AVG_VIDEO_COMPLETE_COST':
      return 'avgVideoCompleteCost';
    case 'CLICKS':
      return 'clicks';
    case 'CPC':
      return 'cpc';
    case 'CPL':
      return 'cpl';
    case 'CPM':
      return 'cpm';
    case 'DRR':
      return 'drr';
    case 'ER':
      return 'er';
    case 'IMPRESSIONS':
      return 'shows';
    case 'REACH':
      return 'reach';
    case 'REVENUE':
      return 'income';
    case 'ROMI':
      return 'romi';
    case 'VTR':
      return 'vtr';
    case 'CONVERSIONS':
      return 'conversions';
    default:
      throw new Error('KPI с бэка не найдено на фронте.');
  }
};

export default getChartIdByKpiName;
